import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardBody,
} from 'reactstrap';
import './PendingPayoffCard.scss';

const PendingPayoffCard = ({
  collateralHeld,
  showCollateral,
}) => {
  const collateralDisplay = collateralHeld && String(collateralHeld).trim()
    ? collateralHeld
    : '-';

  return (
    <Card className="pending-payoff-card">
      <CardHeader className="text-left pending-payoff-card__header">
        <span className="pending-payoff-card__title">
          {showCollateral ? 'Collateral Return' : 'Pending Payoff'}
        </span>
      </CardHeader>
      <CardBody className="pt-2 pending-payoff-card__body">
        {showCollateral ? (
          <div className="pending-payoff-card__collateral">
            <small className="pending-payoff-card__label">Your Collateral</small>
            <div className="pending-payoff-card__amount">{collateralDisplay}</div>
          </div>
        ) : null}
        <div className="pending-payoff-card__alert" role="status">
          <strong className="pending-payoff-card__alert-title">
            Confirming your final payment
          </strong>
          <p className="pending-payoff-card__alert-text">
            {showCollateral ? (
              <>
                Your loan is pending payoff. We&apos;re confirming your final payment has cleared, which typically takes about 7 days. Once that&apos;s done, you&apos;ll be able to request your collateral return here.
              </>
            ) : (
              <>
                Your loan is pending payoff. We&apos;re confirming your final payment has cleared, which typically takes about 7 days.
              </>
            )}
          </p>
        </div>
      </CardBody>
    </Card>
  );
};

PendingPayoffCard.propTypes = {
  collateralHeld: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showCollateral: PropTypes.bool,
};

PendingPayoffCard.defaultProps = {
  collateralHeld: null,
  showCollateral: false,
};

export default PendingPayoffCard;
